import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Sign-in lives in an httpOnly cookie; drop any token left over from the old localStorage scheme
localStorage.removeItem("ezjem_token");
